import React, { Component } from 'react';
import Service from '../service/Service';
const service = new Service();
import Cookies from "js-cookie";
import * as actions from './actions';

import { Link } from "react-router-dom";

import { fetchInitialData } from "../fetchData";

var urlpath = '';

var collectionId = '';
var _createdByUser = false;
var _recordIDParam = '';
var _collIDParam = '';
var _favbabyname = '';
var CommentID_forReply = '';

var recordIDParam;
var collIDParam;
var collectionName;
var favbabyname;
var currentElement;
var createdByUser;
var totalcmnts;
let commentsData = [];
var _commentsData = [];

let repliesData = [];
var commentIDParam;
class SharedCollectionAmp extends Component {
    constructor(props) {
        super(props)
        let initialData = {};
        let favnames = [];
        let coll_name = '';
        let isCreater = false;
        this.alphabetsAry = [];

        for (let i = 0; i < 26; i++) {
            this.alphabetsAry.push((i + 10).toString(36));
        }
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {

            // initialData = window.__initialData__['initialData'];
            favnames = window.__initialData__['initialData']['FinalResponse'];
            coll_name = window.__initialData__['initialData']['collectionName'];
            isCreater = window.__initialData__['initialData']['isCreater'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                favnames = props.staticContext.initialData['initialData']['FinalResponse'];
                coll_name = props.staticContext.initialData['initialData']['collectionName'];
                isCreater = props.staticContext.initialData['initialData']['isCreater'];
            }
        }
        this.state = {
            favnames: favnames,
            coll_name: coll_name,
            isCreater: isCreater,
            commentsData: commentsData,
            repliesData: repliesData,
            metaTitle: "My Favourite Baby Names - FirtsCry Parenting",
            metaDescription: [
                { "name": "description", "content": "Find the latest, most popular and unique baby names for your newborn from a list of 100000+ Baby Boy & Girl Names ideas with FirstCry’s Baby Names Finder." },
                { "name": "keywords", "content": "baby names, unique baby names, popular baby names" },
                { "name": "robots", "content": "all" },
                { "itemprop": "name", "content": "PARENTING.FIRSTCRY.COM" },
                { "itemprop": "description", "content": "Hey , check my cute names collection created on FirstCry baby Names. Explore Now!" },
                { "name": "keywords", "content": "baby names, unique baby names, popular baby names" },
                { "itemprop": "image", "content": "https://cdn.cdnparenting.com/articles/babynameimages/landing_image.webp" },
                // <!-- Facebook Meta Tags -->
                { "property": "og:url", "content": global.redirect_url },
                { "property": "og:type", "content": "website" },
                { "property": "og:title", "content": "PARENTING.FIRSTCRY.COM" },
                { "property": "og:description", "content": "Hey , check my cute names collection created on FirstCry baby Names. Explore Now!" },
                { "name": "keywords", "content": "baby names, unique baby names, popular baby names" },
                { "property": "og:image", "content": "https://cdn.cdnparenting.com/articles/babynameimages/landing_image.webp" },
                // <!-- Twitter Meta Tags -->
                { "name": "twitter:card", "content": "Latest and unique names for yor Li'l ones" },
                { "name": "twitter:title", "content": "PARENTING.FIRSTCRY.COM" },
                { "name": "twitter:description", "content": "Hey , check my cute names collection created on FirstCry baby Names. Explore Now!" },
                { "name": "keywords", "content": "baby names, unique baby names, popular baby names" },
                { "name": "twitter:image", "content": "https://cdn.cdnparenting.com/articles/babynameimages/landing_image.webp" }
            ]
        };
    }

    static initialAction(reqUrl, ftk, authData, uId, childData, cookieData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let size = 10;
        if (reqUrl.includes('/page/')) {
            size = parseInt(reqUrl.split('/').pop()) * 10;
        }

        var collID = reqUrl.split('/')[3];

        var url = global.api_url + "getmyfavouritelistdetails";
        var body = JSON.stringify({
            "pageSize": size,
            "pageNo": 1,
            "collectionId": collID
        });

        return fetchInitialData(url, JSON.stringify(header), body);
    }

    // componentDidMount(){
    //     urlpath = window.location.href;
    //     document.querySelector(".favNames_overlay").style.display = "block";
    //     collectionId = window.location.pathname.split('/')[3];

    //         window.scrollTo(0,0);

    //     document.addEventListener("click", actions.domClick);
    //     if (navigator.onLine) {
    //         let size = 10;
    //         if (this.disPageNo > 1) {
    //             size = 10 * this.disPageNo;
    //         }

    //         if (this.state.favnames.length == 0 || this.state.favnames == "Records Not Found") {
    //             service.showLoader();
    //             this.getfavnames(1, size);
    //         }

    //     } else {
    //         if (localStorage.getItem('favnames')) {
    //             this.setState(
    //                 { favnames: JSON.parse(localStorage.getItem('favnames')) },
    //                 () => { actions.loadSliders(); }
    //             );
    //         }
    //         if(localStorage.getItem('collectionname')){
    //             this.setState({ coll_name : localStorage.getItem('collectionname')});
    //         }

    //         service.showLoader();
    //         setTimeout(function(){

    //             service.hideLoader();
    //         }, 500)
    //     }

    //     actions.loadSliders();
    //     if(this.state.favnames.length == 0 || this.state.favnames == "Records Not Found"){
    //         document.querySelector(".nonames_in_collection").style.display = "block";
    //     }
    // }

    // componentWillUnmount() {
    //     document.removeEventListener("click", actions.domClick);
    // }

    // getfavnames(pageno, size){
    //     var postData = {
    //         "collectionId": collectionId,
    //         "pageSize": size,
    //         "pageNo": pageno
    //     }
    //     var url = global.api_ci_url + "Babynames/getmyfavouritelistdetails";
    //     service.postServiceCall(url, postData).then((json) => {
    //         this.setState({ coll_name : json['collectionName']});
    //         localStorage.setItem('collectionname', json['collectionName']);

    //         if (global.ftk === '' && json['isCreater']) {
    //             window.location.href = loginUrl + "?URL=" + "/baby-names/favorite-baby-names/";
    //             service.showAlert("Please Login");
    //         } else {
    //             document.querySelector(".favNames_overlay").style.display = "block";
    //             if(json['isCreater']){
    //                 this.setState({ isCreater : json['isCreater']});
    //             }

    //             if (json['FinalResponse'] !== "Records Not Found") {
    //                 if (this.state.favnames.length > 0) {
    //                     this.setState({ favnames: json['FinalResponse'] }, () => { service.loadImages(); actions.loadSliders(); });

    //                 } else {
    //                     localStorage.setItem('favnames', JSON.stringify(json['FinalResponse']));
    //                     this.setState({ favnames: json['FinalResponse'] }, () => { service.loadImages(); actions.loadSliders(); });

    //                 }
    //             }

    //         }
    //         service.hideLoader();
    //     }).catch((error) => {
    //         console.error(error);
    //         service.hideLoader();
    //     });
    // }

    // collectionId = global.currentURL.split('/')[3];

    cardShare() {
        if (this.state.isCreater == true) {
            return (
                <div className="card-share right">
                    <div tabIndex="0" role="button" on={`tap: shareopt.toggleVisibility, share-overlay.show`} className="left shareIcon">
                        <div className="left R13_9e fbimg" data-icon-font="J">
                            {/* <amp-img layout="responsive" width="18" height="18" src="//parenting.firstcry.com/personalized-feed/images/facebook-icon.png" alt="facebook" title="facebook" ></amp-img> */}
                        </div>
                        <div data-icon-font="" className="icon left whatsappIcon"></div>
                        <div className="left M14_9e">Share</div>
                    </div>
                    
                    <div className="sharing-options" id="shareopt" hidden>
                        <div data-icon-font="C" className="icon right closeicon" role="button" tabIndex="0" on={`tap:share-overlay.hide, shareopt.hide`}></div>
                        <ul>
                            <li className="whatsapp-share left">
                                <a href={`whatsapp://send?text=${global.currentURL}`} target="_blank">
                                    <span className="M16_61 social-share" id="whatsapp">
                                        <amp-img layout="responsive" width="50" height="50" src={require('../assets/images/whatsapp.png')} alt="" ></amp-img>
                                    </span>
                                </a>
                            </li>
                            <li className="facebook-share left">
                                <a href={`https://www.facebook.com/sharer/sharer.php?u=${global.currentURL}`} target="_blank">
                                    <div className="M16_61 social-share post_share tw_share" id="facebook">
                                        <amp-img layout="responsive" width="50" height="50" src={require('../assets/images/facebook.png')} alt="" ></amp-img>
                                    </div>
                                </a>
                            </li>

                            <li className="twitter-share left"> 
                                <a href={`https://twitter.com/share?url=${global.currentURL}`} target="_blank">
                                    <div className="M16_61 social-share post_share tw_share" id="twitter">
                                        <amp-img layout="responsive" width="50" height="50" src={require('../assets/images/twitter.png')} alt="" ></amp-img>
                                    </div>
                                </a>
                            </li>
                            <li className="twitter-share left post_share pi_share" style={{margin : '0 0 0 10px'}}>
                                <a href={`https://www.pinterest.com/pin/create/button/?url=${global.currentURL}`} target="_blank">
                                    <div className="M16_61 social-share post_share pi_share" id="pintrest">
                                        <amp-img layout="responsive" width="50" height="50" src={require('../assets/images/pintrest.png')} alt="" ></amp-img>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="share-overlay" id="share-overlay" role="button" tabIndex="0" on={`tap:share-overlay.hide, shareopt.hide`} hidden></div>
                </div>
            )
        }
    }

    // openCommentPopupCollection(recordID, collID, collName, babyname, isCreater, event) {
    //     if (global.ftk === '') {
    //         service.showAlert("Please Login");
    //         window.location.href = global.loginUrl + '?URL=' + global.currentURL;
    //     }else{

    //         if (event.target.classList.contains("comment_name")) {
    //             document.querySelector(".commentpopup-overlay").style.display = "block";
    //         } else {
    //             document.querySelector(".addReply-overlay").style.display = "block";
    //         }

    //         recordIDParam = recordID;
    //         collIDParam = collID;
    //         collectionName = collName;
    //         favbabyname = babyname;
    //         currentElement = event.target.className;
    //         createdByUser = isCreater;

    //         var totalcmnttext = event.target.parentElement.querySelector('.commentCounts').getAttribute("data-cmnt");
    //         totalcmnts = Number(totalcmnttext);
    //         document.getElementsByTagName('body')[0].style.overflow = "hidden";
    //     }
    // }
    // postComment() {
    //     var comment = document.getElementById("postcomment").value;
    //     if(/<(.|\n)*?>/g.test(comment)){
    //         document.querySelector('.cmnterror_msg').style.display = "block";
    //         document.querySelector('.cmnterror_msg').innerHTML = 'Script tags not allowed';
    //     }else{
    //         if (comment != '') {
    //             if(global.userAry['Sex']){
    //                 var ge = global.userAry['Sex'];
    //             } else {
    //                 var ge = 'NA'
    //             }

    //             var postData = {
    //                 "recordId" : recordIDParam,
    //                 "collectionId": collIDParam,
    //                 "comment" : comment,
    //                 "collectionName" : collectionName,
    //                 "babyName": favbabyname,
    //                 "userPic" : global.userAry['userPhoto'],
    //                 "userName" : global.userAry['userName'],
    //                 "childArr" : global.userAry['childData'],
    //                 "userGender" : ge
    //             }
    //             var url = global.api_ci_url + "Babynames/savecommentaction";

    //             service.postServiceCall(url, postData).then((json) => {
    //                 if(json['msg'] == 1){
    //                     document.querySelector(".commentpopup-overlay").style.display = "none";
    //                     document.querySelector(".favNames_overlay").style.display = "block";

    //                     setTimeout(() => {
    //                         var temp = this.state.favnames;

    //                         [].forEach.call(temp, function(ele){
    //                             if(ele.recordId == recordIDParam){
    //                                 ele.isCommented = true;
    //                                 ele.comment_count = parseInt(ele.comment_count) + 1;
    //                             }
    //                         })

    //                         this.setState({ favnames: temp });
    //                     }, 500);


    //                     document.getElementById("postcomment").value = "";
    //                     document.querySelector('.cmnterror_msg').style.display = "none";
    //                     document.getElementsByTagName('body')[0].style.overflow = "auto";
    //                 }

    //             }).catch((error) => {
    //                 console.error(error);
    //             });
    //         } else {
    //             if (window.innerWidth < 767) {
    //                 service.showAlert("Please enter your Comment");
    //             } else {
    //                 document.querySelector('.cmnterror_msg').innerHTML = "Please enter your Comment";
    //                 document.querySelector('.cmnterror_msg').style.display = "block";
    //             }
    //         }
    //     }
    // }

    // openReplyPopup(recordId, commentID, collID, collName, babyname, isCreater, event) {
    //     if (global.ftk === '') {
    //         service.showAlert("Please Login");
    //         window.location.href = global.loginUrl + '?URL=' + global.currentURL;
    //     }else{

    //         document.querySelector(".addReply-overlay").style.display = "block";
    //         document.querySelector(".addReply-overlay").querySelector(".popup-header").querySelector(".M14_white").innerHTML = "Add a Reply";

    //         recordIDParam = recordId;
    //         commentIDParam = commentID;
    //         collIDParam = collID;
    //         collectionName = collName;
    //         favbabyname = babyname;
    //         currentElement = event.target.className;
    //         createdByUser = isCreater;

    //         var totalcmnttext = event.target.parentElement.querySelector('.replyCounts').getAttribute("data-cmnt");
    //         totalcmnts = Number(totalcmnttext);
    //         document.getElementsByTagName('body')[0].style.overflow = "hidden";
    //     }
    // }
    // postReply() {
    //     var reply = document.getElementById("postreply").value;
    //     if (/<(.|\n)*?>/g.test(reply)) {
    //         document.querySelector(".addReply-overlay").querySelector('.cmnterror_msg').innerHTML = 'Script tags not allowed';
    //         document.querySelector(".addReply-overlay").querySelector('.cmnterror_msg').style.display = "block";
    //     } else {
    //     if (reply != '') {
    //         if(global.userAry['Sex']){
    //             var ge = global.userAry['Sex'];
    //         } else {
    //             var ge = 'NA'
    //         }
    //         var postData = {
    //             "recordId" : recordIDParam,
    //             "collectionId" : collIDParam,
    //             "commentId" : commentIDParam,
    //             "reply" : reply,
    //             "babyName" : favbabyname,
    //             "collectionName" : collectionName,
    //             "userPic" : global.userAry['userPhoto'],
    //             "userName" : global.userAry['userName'],
    //             "childArr" : global.userAry['childData'],
    //             "userGender" : ge
    //         }

    //         var url = global.api_ci_url + "Babynames/savebabyreplyaction";
    //         service.postServiceCall(url, postData).then((json) => {
    //             document.querySelector(".addReply-overlay").style.display = "none";


    //             this.setState({commentsData : []});
    //             document.getElementById("postreply").value = "";
    //             this.showcomments(recordIDParam, collIDParam, collectionName, favbabyname, createdByUser) 


    //             document.getElementsByTagName('body')[0].style.overflow = "auto";

    //         }).catch((error) => {
    //             console.error(error);
    //             service.hideLoader();
    //         });

    //     } else {
    //         if (window.innerWidth < 767) {
    //             service.showAlert("Please enter reply");
    //         } else {
    //             document.querySelector(".addReply-overlay").querySelector('.cmnterror_msg').innerHTML = "Please enter reply";
    //             document.querySelector(".addReply-overlay").querySelector('.cmnterror_msg').style.display = "block";
    //         }
    //     }
    //     }
    // }
    // showcomments(recordIDParam, collIDParam, collectionName, favbabyname, createdByUser){

    //     service.showLoader();
    //     document.querySelector(".comments_overlay").style.display = "block";
    //     document.querySelector(".favNames_overlay").style.display = "none";

    //     if(_commentsData.length == 0){

    //         _createdByUser = createdByUser;
    //         _recordIDParam = recordIDParam;
    //         _collIDParam = collIDParam;
    //         _favbabyname = favbabyname; 
    //         localStorage.setItem("show_comments", true);
    //         var postData = {
    //             "pageSize" : 100,
    //             "pageNo" : 1,
    //             "recordId" : recordIDParam,
    //             "collectionId" : collIDParam
    //         }

    //         var url = global.api_ci_url + "Babynames/getbabycomments";
    //         service.postServiceCall(url, postData).then((json) => {
    //             if(json['msg'] == 1){
    //                 // document.querySelector(".comments").innerHTML = '';
    //                 document.querySelector(".comments_overlay").style.display = "block";
    //                 document.querySelector(".favNames_overlay").style.display = "none";

    //                 this.setState({ commentsData : json['result']});
    //             }
    //             service.hideLoader();
    //         }).catch((error) => {
    //             console.error(error);
    //             service.hideLoader();
    //         });
    //     }

    //     service.hideLoader();
    // }

    // showreplies(recordId, commentId, collID) {
    //     service.showLoader();
    //     var postData = {
    //         "recordId" : recordId,
    //         "commentId" : commentId,
    //         "collectionId" : collID,
    //         "pageNo" : '1',
    //         "pageSize" : '10'
    //     }

    //     var url = global.api_ci_url + "Babynames/getbabyreplybycomment"
    //     service.postServiceCall(url, postData).then((json) => {

    //         CommentID_forReply = commentId;

    //         this.setState({ repliesData : json['result']}, () =>  service.loadImages());


    //         document.querySelector(".replies_overlay").style.display = "block";
    //         document.querySelector(".comments_overlay").style.display = "none";

    //         service.hideLoader();
    //     }).catch((error) => {
    //         console.error(error);
    //         service.hideLoader();
    //     });

    //     service.hideLoader();
    // }
    // showCollection(){
    //     document.querySelector(".comments_overlay").style.display = "none";
    //     document.querySelector(".favNames_overlay").style.display = "block";
    // }
    // showCommentPage(){
    //     document.querySelector(".replies_overlay").style.display = "none";
    //     this.setState({repliesData: []})
    //     document.querySelector(".comments_overlay").style.display = "block";

    // }
    // addReply_close() {
    //     document.querySelector(".addReply-overlay").style.display = "none";
    //     document.querySelector(".commentpopup-overlay").style.display = "none";
    //     document.getElementById("postcomment").value = '';
    //     document.getElementById("postreply").value = '';
    //     document.querySelector('.cmnterror_msg').style.display = "none";
    //     document.getElementsByTagName('body')[0].style.overflow = "auto";
    // }

    // likeFavName(recordId, collId, collName, babyName, likeCount, event) {
    //     if (global.ftk === '') {
    //         service.showAlert("Please Login");
    //         window.location.href = global.loginUrl + '?URL=' + global.currentURL;
    //     }else{
    //         var action_status;
    //         if (event.target.classList.contains("isliked")) {
    //             action_status = "0";
    //         } else {
    //             action_status = "1";
    //         }
    //         var postData = {
    //             "recordId" : recordId,
    //             "collectionId" : collId,
    //             "collectionName" : collName,
    //             "babyName" : babyName,
    //             "postType" : "0",
    //             "commentId" : "",
    //             "action_status" : action_status,
    //         }
    //         var element = event.target;
    //         var url = global.api_ci_url + "Babynames/savebabylikeaction";
    //         service.postServiceCall(url, postData).then((json) => {
    //             if(json['msg'] == 1){
    //                 var temp = this.state.favnames;

    //                 [].forEach.call(temp, function(ele){
    //                     if(ele.recordId == recordId){
    //                         if(action_status == "1"){
    //                             ele.isLiked = true;
    //                             ele.like_count = parseInt(ele.like_count) + 1;
    //                         } else {
    //                             ele.isLiked = false;
    //                             ele.like_count = (parseInt(ele.like_count) - 1)  >= 0 ? parseInt(ele.like_count) - 1 : 0;;
    //                         }
    //                     }
    //                 })

    //                 this.setState({ favnames: temp });

    //             }
    //           }).catch((error) => {
    //               console.error(error);
    //           });

    //     }
    // }

    // removeFromColl(recordId, favId, babyname, event){
    //     if(navigator.onLine){

    //         if (favId == "0") {
    //             var favouriteId = event.target.getAttribute("data-favid");
    //         } else {
    //             var favouriteId = favId;
    //         }
    //         var postData = {   
    //             "favouriteId" : favouriteId,
    //             "recordId": recordId,
    //             "collectionId": "",
    //             "action_status": "0"
    //         };

    //         var currentEle = event.target;
    //         var url = global.api_ci_url + "Babynames/savefavouritename";
    //         service.postServiceCall(url, postData).then((json) => {
    //             service.hideLoader();
    //             if(json['msg'] == "1"){

    //                 document.querySelector(".nm-add span").innerHTML = babyname + ' has been removed from list';
    //                 document.querySelector(".name-added").classList += " add_show";

    //                 setTimeout(() => {
    //                     document.getElementsByClassName('name-added')[0].className = document.getElementsByClassName('name-added')[0].className.replace(/\add_show\b/, "");
    //                 }, 1000);

    //                 setTimeout(() => {
    //                     var tempArray = this.state.favnames;

    //                     var finalArray = [];
    //                 for(var i = 0; i < tempArray.length; i++){

    //                         if(tempArray[i].recordId !== recordId){ 
    //                             finalArray.push(tempArray[i]); //add remaining names in new array
    //                         }   
    //                     }
    //                     this.setState({ favnames: finalArray});

    //                     if(this.state.favnames.length == 0 || this.state.favnames == "Records Not Found"){
    //                         document.querySelector(".nonames_in_collection").style.display = "block";
    //                     }
    //                 }, 500);

    //             } else {
    //                 window.location.href = service.getRedirectUrl(currentURL);
    //             }
    //         }).catch((error) => {
    //             console.error(error);
    //             service.hideLoader();
    //         });
    //     } else {
    //         service.showAlert("Please check internet connection!!!");
    //     }
    // }

    // likeToComment(recordId, commentId, replyId, collId, collName, babyName, likeCount, postType, event) {
    //     if (global.ftk === '') {
    //         service.showAlert("Please Login");
    //         window.location.href = global.loginUrl + '?URL=' + global.currentURL;
    //     }else{
    //         var action_status;
    //         if (event.target.classList.contains("isliked")) {
    //             action_status = "0";
    //         } else {
    //             action_status = "1";
    //         }
    //         var postData = {
    //             "commentId" : commentId,
    //             "collectionId" : collId,
    //             "collectionName" : collName,
    //             "babyName" : babyName,
    //             "postType" : postType,
    //             "action_status" : action_status,
    //             "action_type" : "like",
    //             "recordId" : recordId,
    //             "replyId" : replyId
    //         }
    //         var element = event.target;

    //         var url = global.api_ci_url + "Babynames/savebabylikeaction";

    //         service.postServiceCall(url, postData).then((json) => {

    //             if (json['result'] == "success") {

    //                 if(postType == "1"){

    //                     var tempArray = this.state.commentsData;
    //                     if(action_status == "0"){
    //                         [].forEach.call(tempArray, function(ele){
    //                             if(ele.commentId == commentId){
    //                                 ele.isLiked = false;
    //                                 ele.likeCount = parseInt(ele.likeCount) - 1
    //                             }

    //                         })

    //                     } else {
    //                         [].forEach.call(tempArray, function(ele){
    //                             if(ele.commentId == commentId){
    //                                 ele.isLiked = true;
    //                                 ele.likeCount = parseInt(ele.likeCount) + 1;
    //                             }
    //                         })
    //                     }
    //                     this.setState({commentsData : tempArray});
    //                 } else {
    //                     var tempArray = this.state.repliesData;
    //                     if(action_status == "0"){
    //                         [].forEach.call(tempArray, function(ele){
    //                             if(ele.replyId == replyId){
    //                                 ele.isLiked = false;
    //                                 ele.likeCount = parseInt(ele.likeCount) - 1
    //                             }
    //                         })

    //                     } else {
    //                         [].forEach.call(tempArray, function(ele){
    //                             if(ele.replyId == replyId){
    //                                 ele.isLiked = true;
    //                                 ele.likeCount = parseInt(ele.likeCount) + 1;
    //                             }
    //                         })
    //                     }
    //                     this.setState({repliesData : tempArray});

    //                 }


    //                 // if (element.classList.contains("isliked")) {
    //                 //     element.className = element.className.replace(/\isliked\b/, '');

    //                 //     if (likeCount == 1) {
    //                 //         var updatedlikeCount = likeCount - 1;
    //                 //         _likeCnt_text.innerHTML = '';
    //                 //         _likeCnt_text.innerHTML = updatedlikeCount + " Like";
    //                 //         _likeCnt_text.style.display = "none";
    //                 //     } else if (likeCount > 1) {
    //                 //         var updatedlikeCount = likeCount - 1;
    //                 //         _likeCnt_text.innerHTML = '';
    //                 //         _likeCnt_text.innerHTML = updatedlikeCount + " Likes";
    //                 //     } else {
    //                 //         _likeCnt_text.style.display = "none";
    //                 //     }
    //                 // } else {
    //                 //     element.classList += " isliked";
    //                 //     var originalCount = _likeCnt_text.innerHTML;

    //                 //     if (originalCount == "0 like" || originalCount == "" || originalCount == "0 Likes" || originalCount == "0 Like") {
    //                 //         _likeCnt_text.innerHTML = '';
    //                 //         _likeCnt_text.innerHTML = "1 Like";
    //                 //         _likeCnt_text.style.display = "block";
    //                 //     } else {
    //                 //         var updatedlikeCount = likeCount + 1;
    //                 //         if (updatedlikeCount == 1) {
    //                 //             _likeCnt_text.innerHTML = '';
    //                 //             _likeCnt_text.innerHTML = updatedlikeCount  + " Likes";
    //                 //             _likeCnt_text.style.display = "block";
    //                 //         } else {
    //                 //             _likeCnt_text.innerHTML = '';
    //                 //             _likeCnt_text.innerHTML = updatedlikeCount + " Likes";
    //                 //             _likeCnt_text.style.display = "block";
    //                 //         }
    //                 //     }
    //                 // }
    //             }
    //         }).catch((error) => {
    //             console.error(error);
    //             service.hideLoader();
    //         });
    //     }
    // }
    render() {
        
        collectionId = global.currentURL.split('/')[5];
        
        var _collectionName = this.state.coll_name;
        var iscreater = this.state.isCreater;

        var _favNameData = this.state.favnames;

        _commentsData = this.state.commentsData;
        var _repliesData = this.state.repliesData;
        
        return (
            <main className="baby-names-main main-container">
                <div className="data-container">
                    <meta name="atdlayout" content="babynames_ap" />
                    <div className="title">
                        <div className="breadcrumb R11_9e">
                            <a className="R11_9e" href={service.getRedirectUrl("/")}>Home</a>
                            <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                            <a className="R11_9e" href={service.getRedirectUrl("/baby-names/")} target="_self">Baby Names</a>
                        </div>
                        <h1 className="B24_00">Baby Names</h1>
                    </div>
                    <div className="sub-container">
                        <div className="shared_favorite_container left">
                            {/*  <!--favorite names list starts-->*/}
                            <div className="favNames_overlay" id="favNames_overlay">
                                <div className="favNames_popup">
                                    <div className="collection_title">
                                        <a href={service.getRedirectUrl(`/baby-names/favorite-baby-names/amp/`)} className="left">
                                            <span className="icon left backtocollList" data-icon-font="s"></span>
                                        </a>
                                        <span className="M16_white left collHeading">{_collectionName}</span>
                                        {
                                            (this.state.favnames !== "Records Not Found" && this.state.favnames.length > 0) ?
                                            this.cardShare() :
                                            ''
                                        }
                                    </div>
                                        {(_favNameData !== "Records Not Found") ?
                                            (
                                                <ul className="favNames">
                                                {_favNameData.map((value, key) => (
                                                    <li data-record-id={value.recordId} key={key} id={value.recordId}>
                                                        {/* <div className=""> */}

                                                            <form method="post" action-xhr={`${global.hosturl}parenting/BabynamesAmp/tonameDetails`} encType="application/json"  className="favname_details">
                                                                <input type="hidden" name="Babyname" value={value.babyname}/>
                                                                <input type="hidden" name="BabynameId" value={value.recordId}/>
                                                                <label htmlFor={`name${value.recordId}`}>
                                                                    <div>
                                                                        {
                                                                            (value.gender == "Boy") ?
                                                                            (<span className="icon left" data-icon-font="&#xe022;"></span>)
                                                                            :
                                                                            (
                                                                            (value.gender == "Girl") ?
                                                                            (<span className="icon left" data-icon-font="&#xe01f;"></span>)
                                                                            :
                                                                            (<span className="icon left" data-icon-font="&#xe029;"></span>)
                                                                            )
                                                                        }
                                                                       <div className="left favname_meaning">
                                                                            <div className="M14_pink">{value.babyname}</div>
                                                                            <div className="R14_9e fav_meaning">{value.meaning}</div>
                                                                        </div>
                                                                    </div>
                                                                </label>
                                                                <input type="submit" value="" hidden id={`name${value.recordId}`}/>
                                                            </form>
                                                        {/* </div> */}
                                                        <div className="favname_actions">
                                                            {
                                                                <form method="post" className="left" action-xhr={`${global.hosturl}parenting/BabynamesAmp/savebabylikeaction`} encType="application/json">

                                                                    <input type="hidden" name="commentId" value="" />
                                                                    <input type="hidden" name="collectionId" value={collectionId} />
                                                                    <input type="hidden" name="collectionName" value={_collectionName} />
                                                                    <input type="hidden" name="recordId" value={value.recordId} />
                                                                    <input type="hidden" name="replyId" value={value.replyId} />
                                                                    <input type="hidden" name="babyName" value={value.babyname} />
                                                                    <input type="hidden" name="postType" value="0" />
                                                                    <input type="hidden" name="action_type" value="" />
                                                                    <input type="hidden" name="headerdata" value={'ftk:' + global.ftk + ',,uid:' + global.uID + ',,access-token:' + global.accessToken + ',,user-agent:' + global.userAgent + ',,isdesktop:' + global.isdesktop} />
                                                                    <input type="hidden" name="currentUrl" value={global.currentURL} />
                                                                    {value.isLiked ?
                                                                        (
                                                                            <label htmlFor={`likeClk${value.recordId}`}>
                                                                                <input type="hidden" name="action_status" value="0" />
                                                                                <input type="hidden" name="action_type" value="" />
                                                                                <input type="submit" role="button" id={`likeClk${value.recordId}`} tabIndex="0" value="" />
                                                                                <span className="icon left like_name isliked" data-icon-font="T" data-id={collectionId} ></span>
                                                                            </label>
                                                                        ) :
                                                                        (
                                                                            <label htmlFor={`likeClk${value.recordId}`}>
                                                                                <input type="hidden" name="action_status" value="1" />
                                                                                <input type="hidden" name="action_type" value="" />
                                                                                <input type="submit" role="button" id={`likeClk${value.recordId}`} tabIndex="0" value="" />
                                                                                <span className="icon left like_name" data-icon-font="T" data-id={collectionId}></span>
                                                                            </label>
                                                                        )
                                                                    }
                                                                </form>
                                                            }

                                                            {
                                                                // (value.isCommented) ?
                                                                //     (
                                                                //         <span className="icon left comment_name isliked" data-icon-font="e" role="button" tabIndex="0" on={`tap:commentpopup-overlay.show,AMP.setState({recordIDParam : '${value.recordId}',collIDParam : '${collectionId}',collectionName : '${_collectionName}',favbabyname : '${value.babyname}',createdByUser : '${iscreater}',currentElement : ''})`} onClick={(e) => this.openCommentPopupCollection(`${value.recordId}`, `${collectionId}`, `${_collectionName}`, `${value.babyname}`, `${iscreater}`, e)}></span>
                                                                //     )
                                                                //     :
                                                                //     (
                                                                //         <span className="icon left comment_name" data-icon-font="e" role="button" tabIndex="0" on={`tap:commentpopup-overlay.show,AMP.setState({recordIDParam : '${value.recordId}',collIDParam : '${collectionId}',collectionName : '${_collectionName}',favbabyname : '${value.babyname}',createdByUser : '${iscreater}',currentElement : ''})`} onClick={(e) => this.openCommentPopupCollection(`${value.recordId}`, `${collectionId}`, `${_collectionName}`, `${value.babyname}`, `${iscreater}`, e)}></span>
                                                                //     )
                                                            }

                                                            {
                                                                (value.like_count > 1) ?
                                                                    (
                                                                        <span className="R13_9e likeCounts" onClick={(e) => actions.showUserLikes(`${value.recordId}`, `${collectionId}`, ` `, ` `, 0)} data-like-cnt={value.like_count}>
                                                                            {value.like_count} Likes
                                                                        </span>
                                                                    ) :
                                                                    (
                                                                        (value.like_count == 1) ?
                                                                            (
                                                                                <span className="R13_9e likeCounts" onClick={(e) => actions.showUserLikes(`${value.recordId}`, `${collectionId}`, ` `, ` `, 0)} data-like-cnt={value.like_count}>
                                                                                    {value.like_count} Like
                                                                                </span>
                                                                            ) :
                                                                            (
                                                                                <span className="R13_9e likeCounts" onClick={(e) => actions.showUserLikes(`${value.recordId}`, `${collectionId}`, ` `, ` `, 0)} data-like-cnt={value.like_count}></span>
                                                                            )
                                                                    )
                                                            }
                                                            
                                                            {/* <form method="post" class="left" id="getbabycomments" action-xhr={`${global.hosturl}parenting/BabynamesAmp/getbabycomments`} encType="application/json">
                                                                <input type="hidden" name="recordId" value={value.recordId} />
                                                                <input type="hidden" name="collectionId" value={collectionId} />
                                                                <input type="hidden" name="replyId" value={value.replyId} />
                                                                <input type="hidden" name="babyName" value={value.babyname} />
                                                                <input type="hidden" name="iscreater" value={iscreater} />
                                                                <input type="hidden" name="commentsData" value={_commentsData} />
                                                                <input type="hidden" name="headerdata" value={'ftk:' + global.ftk + ',,uid:' + global.uID + ',,access-token:' + global.accessToken + ',,user-agent:' + global.userAgent + ',,isdesktop:' + global.isdesktop} />
                                                                <input type="hidden" name="currentUrl" value={global.currentURL} />
                                                            {
                                                                (value.comment_count > 1) ?
                                                                    (  
                                                                        <label htmlFor="commentAction">
                                                                            <input type="submit" id="commentAction" value=""/>
                                                                            <span className="R13_9e commentCounts"  role="button" tabIndex="0" on="tap:comments_overlay.show,favNames_overlay.hide" onClick={(e) => this.showcomments(`${value.recordId}`, `${collectionId}`, `${_collectionName}`, `${value.babyname}`, `${iscreater}`)} data-cmnt={value.comment_count}>{value.comment_count} Comments</span>
                                                                        </label>    
                                                                    ) :
                                                                    (
                                                                        (value.comment_count == 1) ?
                                                                            (
                                                                                <label htmlFor="commentAction">
                                                                                    <input type="submit" id="commentAction" value=""/>
                                                                                    <span className="R13_9e commentCounts" role="button" tabIndex="0" on="tap:comments_overlay.show,favNames_overlay.hide">{value.comment_count} Comment</span>
                                                                                </label>
                                                                            ) :
                                                                            (
                                                                                <label htmlFor="commentAction">
                                                                                    <input type="submit" id="commentAction" value=""/>
                                                                                    <span className="R13_9e commentCounts" role="button" tabIndex="0" on="tap:comments_overlay.show,favNames_overlay.hide">{value.comment_count} Comments</span>
                                                                                </label>
                                                                            )
                                                                    )
                                                            }
                                                            </form> */}
                                                            <form method="post" className="right" action-xhr={`${global.hosturl}parenting/BabynamesAmp/savefavouritename`} encType="application/json">
                                                                <input type="hidden" name="recordId" value={value.recordId} />
                                                                <input type="hidden" name="favouriteId" value={value.favouriteid} />
                                                                <input type="hidden" name="action_status" value="0" />
                                                                <input type="hidden" name="headerdata" value={'ftk:' + global.ftk + ',,uid:' + global.uID + ',,access-token:' + global.accessToken + ',,user-agent:' + global.userAgent + ',,isdesktop:' + global.isdesktop} />
                                                                <input type="hidden" name="currentUrl" value={global.currentURL} />
                                                                <input type="hidden" name="collectionId" value={collectionId} />
                                                                {
                                                                (iscreater == true) ?
                                                                    (
                                                                            <label htmlFor={`heartClk1${value.recordId}`}>
                                                                                <input type="submit"  id={`heartClk1${value.recordId}`} value="" tabIndex="0" role="button" />
                                                                                <span className="icon right favourite_icon" id="dev_cll_hrt_1" data-icon-font="}" data-id={value.recordId} ></span>
                                                                            </label>
                                                                    )
                                                                    : ''
                                                            }
                                                            </form>
                                                        </div>
                                                    </li>
                                                ))}
                                                </ul>
                                            ) :
                                            <div className="nonames_in_collection" id="nonames_in_collection">
                                                <div className="R14_42">You have not marked any name as favourite</div>
                                                <div className="M14_pink">Find best name for your loved one...</div>
                                                <div className="R14_42">
                                                    Add tap on
                                                    <span className="icon isChecked" data-icon-font="+" >
                                                    </span>
                                                        icon to make your favourite list
                                                </div>
                                            </div>
                                        }
                                    <div className="pagination-sec">
                                        <div className="page-nav td-pb-padding-side"></div>
                                    </div>
                                </div>
                            </div>
                            {/*  <!--favorite names list ends-->  */}
                            {/*  <!--comment popup starts-->  */}
                            <div className="commentpopup-overlay left" id="commentpopup-overlay" hidden>
                                <form method="post" id="savecommentaction" action-xhr={`${global.hosturl}parenting/BabynamesAmp/savecommentaction`} encType="application/json">
                                    <input type="hidden" name="headerdata" value={'ftk:' + global.ftk + ',,uid:' + global.uID + ',,access-token:' + global.accessToken + ',,user-agent:' + global.userAgent + ',,isdesktop:' + global.isdesktop} />
                                    <input type="hidden" name="currentUrl" value={global.currentURL} />
                                    <input type="hidden" name="recordIDParam" data-amp-bind-value="recordIDParam" />
                                    <input type="hidden" name="collIDParam" data-amp-bind-value="collIDParam" /><input type="hidden" name="collectionName" data-amp-bind-value="collectionName" /><input type="hidden" name="favbabyname" data-amp-bind-value="favbabyname" />
                                    <input type="hidden" name="createdByUser" data-amp-bind-value="createdByUser" />
                                    <input type="hidden" name="userPic" value={global.userAry['userPhoto']} />
                                    <input type="hidden" name="userName" value={global.userAry['userName']} />
                                    <input type="hidden" name="childArr" value={global.userAry['childData']} />
                                    <input type="hidden" name="userGender" value={global.userAry['Sex']} />
                                    <div className="addReply-popup">
                                        <div className="popup-header">
                                            <span className="icon addReplyClose fl-lft" data-icon-font="s" role="button" tabIndex="0" on="tap:addReply-overlay.hide,commentpopup-overlay.hide" onClick={(e) => this.addReply_close()}></span>
                                            <span className="M14_white">Add a Comment</span>
                                        </div>
                                        <div className="addReply-wrap clearfix">
                                            <textarea placeholder="Write Your Comment Here" id="postcomment" name="postcomment"></textarea>
                                            <span className="cmnterror_msg R11_red"></span>
                                            <label htmlFor="saveComment">
                                                <input type="submit" value="" id="saveComment"/>
                                                <span className="post-btn M14_white" onClick={() => this.postComment()}>POST &nbsp;<span className="icon replyIcon" data-icon-font=""></span>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            {/*  <!--comment poup ends-->  */}
                            {/*  <!--comment popup starts-->  */}
                            <div className="addReply-overlay left" id="addReply-overlay" hidden>
                                {/*  <!--<form id="commentadd" method="POST" className="form-horizontal" enctype="multipart/form-data">-->  */}
                                <div className="addReply-popup">
                                    <div className="popup-header">
                                        <span className="icon addReplyClose fl-lft" data-icon-font="s" onClick={(e) => this.addReply_close()}></span>
                                        <span className="M14_white">Add a Reply</span>
                                    </div>
                                    <div className="addReply-wrap clearfix">
                                        <textarea placeholder="Write Your Comment Here" id="postreply" name="postreply"></textarea>
                                        <span className="cmnterror_msg R11_red"></span>
                                        <span className="post-btn M14_white dev_reply" onClick={() => this.postReply()}>POST &nbsp;<span className="icon replyIcon dev_reply" data-icon-font=""></span>
                                        </span>
                                    </div>
                                </div>
                                {/*  <!--</form>-->  */}
                            </div>
                            {/*  <!--comment poup ends-->  */}
                            {/*  <!--liked users list popup starts-->  */}
                            <div className="likes-overlay left" id="likes-overlay" hidden>
                                <div className="likes-popup" id="dev_like_pop">
                                    <div className="popup-header">
                                        <span className="icon likesClose fl-lft" data-icon-font="s" onClick={(e) => actions.closeLikedUserPopup(e)}></span>
                                        <span className="M14_white">Likes</span>
                                    </div>
                                    <div className="likes-wrap">
                                        <ul>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/*  <!--liked users list ends-->  */}

                            {/*  <!--comments list starts-->  */}
                            <div className="comments_overlay left" id="comments_overlay" hidden>
                                <div className="comments_popup" id="dev_comt_pop">
                                    <div className="comments_title">
                                        <span className="icon left backtocoll" data-icon-font="s" role="button" tabIndex="0" on="tap:comments_overlay.hide,favNames_overlay.show" onClick={() => this.showCollection()}></span>
                                        <span className="M14_white left">Comments</span>
                                    </div>
                                    <ul className="comments">
                                        {
                                            _commentsData.map((value, index) =>
                                                (
                                                    <li key={index} id={`reply_${value.commentId}`}><div className="experts-details">
                                                        <span className="experts-photo">

                                                            {
                                                                ((value.userPic == '' || value.userPic == null || value.userPic == undefined)) ?
                                                                    (
                                                                        (value.usergender == "female") ?
                                                                            (
                                                                                <img className="imgcheck" src="https://cdn.cdnparenting.com/articles/babynameimages/mother_profile.png" />
                                                                            )
                                                                            :
                                                                            (
                                                                                (value.usergender == "male") ?
                                                                                    (<img className="imgcheck" src="https://cdn.cdnparenting.com/articles/babynameimages/father_profile.png" />) :
                                                                                    (<img className="imgcheck" src="https://cdn.cdnparenting.com/articles/babynameimages/default-img.png" />)
                                                                            )

                                                                    ) :
                                                                    (<img className="imgcheck" src={value.userPic} />)
                                                            }
                                                        </span>
                                                        <span className="experts-name"><span className="exp-name M14_42">{value.userName}</span><span className="R13_9e experts-desc">{value.userDesc}</span></span><span className="R13_9e right">{value.commentDate}</span><div className="R14_42">{value.comment}</div></div><div className="favname_actions">

                                                            {(value.isLiked) ?
                                                                (<span className="icon left like_name isliked" data-icon-font="T" onClick={(e) => this.likeToComment(`${_recordIDParam}`, `${value.commentId}`, ``, `${_collIDParam}`, `${_collectionName}`, `${_favbabyname}`, value.likeCount, "1", e)}></span>)
                                                                :
                                                                (<span className="icon left like_name" data-icon-font="T" onClick={(e) => this.likeToComment(`${_recordIDParam}`, `${value.commentId}`, ``, `${_collIDParam}`, `${_collectionName}`, `${_favbabyname}`, value.likeCount, "1", e)}></span>)
                                                            }

                                                            {(value.isReplied) ?
                                                                (<span className="icon left replyicon isliked" data-icon-font="e" onClick={(e) => this.openReplyPopup(`${_recordIDParam}`, `${value.commentId}`, `${_collIDParam}`, `${_collectionName}`, `${_favbabyname}`, `${_createdByUser}`, e)}></span>)
                                                                :
                                                                (<span className="icon left replyicon" data-icon-font="e" onClick={(e) => this.openReplyPopup(`${_recordIDParam}`, `${value.commentId}`, `${_collIDParam}`, `${_collectionName}`, `${_favbabyname}`, `${_createdByUser}`, e)}></span>)
                                                            }

                                                            {(value.likeCount > 1) ?
                                                                (<span className="R13_9e likeCounts" onClick={(e) => actions.showUserLikes(`${_recordIDParam}`, `${_collIDParam}`, `${value.commentId}`, ` `, 1)}>{value.likeCount} Likes</span>)
                                                                :
                                                                (
                                                                    (value.likeCount == 1) ?
                                                                        (<span className="R13_9e likeCounts" onClick={(e) => actions.showUserLikes(`${_recordIDParam}`, `${_collIDParam}`, `${value.commentId}`, ` `, 1)}>{value.likeCount} Like</span>)
                                                                        :
                                                                        (<span className="R13_9e likeCounts" onClick={(e) => actions.showUserLikes(`${_recordIDParam}`, `${_collIDParam}`, `${value.commentId}`, ` `, 1)}></span>)
                                                                )
                                                            }
                                                             {/* <form method="post" id="savebabylikeaction" action-xhr={`${global.hosturl}parenting/BabynamesAmp/savebabylikeaction`} encType="application/json">
                                                                <input type="hidden" name="recordId" value={_recordIDParam} />
                                                                <input type="hidden" name="commentId" value={value.commentId} />
                                                                <input type="hidden" name="collectionName" value={_collectionName} />
                                                                <input type="hidden" name="collectionId" value={_collIDParam} />
                                                                <input type="hidden" name="replyId" value={value.replyId} />
                                                                <input type="hidden" name="babyName" value={_favbabyname} />
                                                              
                                                                <input type="hidden" name="headerdata" value={'ftk:' + global.ftk + ',,uid:' + global.uID + ',,access-token:' + global.accessToken + ',,user-agent:' + global.userAgent + ',,isdesktop:' + global.isdesktop} />
                                                                <input type="hidden" name="currentUrl" value={global.currentURL} /> */}
                                                            {(value.replyCount > 1) ?
                                                                (<label htmlFor="commentPage">
                                                                    <input type="submit" id="commentPage" value=""/>
                                                                    <span className="R13_9e commentCounts replyCounts" role="button" tabIndex="0" on="tap:" onClick={(e) => this.showreplies(`${_recordIDParam}`, `${value.commentId}`, `${_collIDParam}`, `${_collectionName}`, `${_favbabyname}`, `${_createdByUser}`)} data-cmnt={value.replyCount}>{value.replyCount} Replies</span>
                                                                    </label>
                                                                    )
                                                                :
                                                                (
                                                                    (value.replyCount == 1) ?
                                                                        (<span className="R13_9e commentCounts replyCounts" onClick={(e) => this.showreplies(`${_recordIDParam}`, `${value.commentId}`, `${_collIDParam}`, `${_collectionName}`, `${_favbabyname}`, `${_createdByUser}`)} data-cmnt={value.replyCount}>{value.replyCount} Reply</span>)
                                                                        :
                                                                        (<span className="R13_9e commentCounts replyCounts" onClick={(e) => this.showreplies(`${_recordIDParam}`, `${value.commentId}`, `${_collIDParam}`, `${_collectionName}`, `${_favbabyname}`, `${_createdByUser}`)} data-cmnt={value.replyCount}></span>)
                                                                )
                                                            }
                                                            {/* </form> */}
                                                            {
                                                                (global.userAry['mycid'] != value.commentCreatorId && this.state.isCreater) ?
                                                                    (
                                                                        (!value.isAbuse) ?
                                                                            (
                                                                                <React.Fragment><span className="R13_9e icon abuse_icon right" data-icon-font="&#xe002;" onClick={(e) => actions.showTool(e)}></span>
                                                                                    <div className="abuse-tooltip R14_9e abused_already" onClick={(e) => actions.reportAbuse(`${_recordIDParam}`, `${_collIDParam}`, `${value.commentId}`, ` `, e, this)}
                                                                                    >Report Abuse</div>
                                                                                </React.Fragment>)
                                                                            :
                                                                            (
                                                                                <React.Fragment><span className="R13_9e icon abuse_icon right isChecked" data-icon-font="&#xe002;" onClick={(e) => actions.showTool(e)}></span>
                                                                                    <div className="abuse-tooltip R14_9e abused_already">Already reported abuse.</div>
                                                                                </React.Fragment>
                                                                            )
                                                                    ) :
                                                                    ''
                                                            }
                                                        </div>
                                                        {
                                                            (value.lastreply.length > 0) ?
                                                                (value.lastreply.map((value_rply, index) => (
                                                                    <div className="latest_comment" key={index}><div className="experts-details"><span className="experts-photo left">
                                                                        {
                                                                            (value_rply.userPic == '' || value_rply.userPic == null || value_rply.userPic == undefined) ?
                                                                                (
                                                                                    (value_rply.usergender == "female") ?
                                                                                        (<img className="imgcheck" src="https://cdn.cdnparenting.com/articles/babynameimages/mother_profile.png" />)
                                                                                        :
                                                                                        (
                                                                                            (value_rply.usergender == "male") ?
                                                                                                (<img className="imgcheck" src="https://cdn.cdnparenting.com/articles/babynameimages/father_profile.png" />) :
                                                                                                (<img className="imgcheck" src="https://cdn.cdnparenting.com/articles/babynameimages/default-img.png" />)
                                                                                        )
                                                                                ) :
                                                                                (<img className="imgcheck" src={value_rply.userPic} />)
                                                                        }

                                                                    </span><span className="experts-name"><span className="exp-name M14_42">{value_rply.userName}</span><span className="R13_9e experts-desc">{value_rply.userDesc}</span></span><span className="R13_9e right">{value_rply.replyDate}</span><div className="R14_42 recent_cmnt left">{value_rply.reply}</div>

                                                                        {(global.userAry['mycid'] != value_rply.replyCreatorId && this.state.isCreater) ?
                                                                            (
                                                                                (!value_rply.isAbuse) ?
                                                                                    (<React.Fragment>
                                                                                        <span className="R13_9e icon right recent_reply_abuse abuse_icon" data-icon-font="&#xe002;" onClick={(e) => actions.showTool(e)}></span>
                                                                                        <div className="recent_reply_abuse-tooltip abuse-tooltip R14_9e" onClick={(e) => actions.reportAbuse(`${_recordIDParam}`, `${_collIDParam}`, `${value.commentId}`, `${value_rply.replyId}`, e, this)}>
                                                                                            Report Abuse</div>
                                                                                    </React.Fragment>
                                                                                    )
                                                                                    :
                                                                                    (<React.Fragment>
                                                                                        <span className="R13_9e icon recent_reply_abuse abuse_icon right isChecked" data-icon-font="&#xe002;" onClick={(e) => actions.showTool(e)}></span>';
                                                                                        <div className="recent_reply_abuse-tooltip abuse-tooltip R14_9e abused_already">Reported Abuse Already</div>
                                                                                    </React.Fragment>)
                                                                            ) :
                                                                            ''
                                                                        }
                                                                    </div></div>
                                                                )
                                                                )) :
                                                                (<div className="first_reply"></div>)
                                                        }
                                                    </li>
                                                )
                                            )
                                        }
                                    </ul>
                                </div>
                            </div>
                            {/*  <!--comments list ends-->  */}
                            {/*  <!--replies list starts-->  */}
                            <div className="replies_overlay left" id="replies_overlay" hidden>
                                <div className="replies_popup">
                                    <div className="replies_title">
                                        <span className="icon left backtocomments" data-icon-font="s" onClick={() => this.showCommentPage()}></span>
                                        <span className="M14_white left">Replies</span>
                                    </div>
                                    <ul className="replies">
                                        {
                                            _repliesData.map((value, index) =>
                                                <li key={index}>
                                                    <div className="experts-details">
                                                        <span className="experts-photo">
                                                            {
                                                                (value.userPic == '' || value.userPic == null || value.userPic == undefined) ?
                                                                    (
                                                                        (value.usergender == "female") ?
                                                                            (
                                                                                <img className="imgcheck" src="https://cdn.cdnparenting.com/articles/babynameimages/mother_profile.png" />
                                                                            )
                                                                            :
                                                                            (
                                                                                (value.usergender == "male") ?
                                                                                    (<img className="imgcheck" src="https://cdn.cdnparenting.com/articles/babynameimages/father_profile.png" />) :
                                                                                    (<img className="imgcheck" src="https://cdn.cdnparenting.com/articles/babynameimages/default-img.png" />)
                                                                            )

                                                                    ) :
                                                                    (<img className="imgcheck" src={value.userPic} />)

                                                            }
                                                        </span>

                                                        <span className="experts-name">
                                                            <span className="exp-name M14_42">
                                                                {value.userName}</span>
                                                            <span className="R13_9e experts-desc">{value.userDesc}</span>
                                                        </span>

                                                        <span className="R13_9e right">{value.replyDate}</span>
                                                        <div className="R14_42">{value.reply}</div>
                                                    </div>

                                                    <div className="favname_actions">
                                                        {
                                                            <form method="post" id="savebabylikeaction" action-xhr={`${global.hosturl}parenting/BabynamesAmp/savebabylikeaction`} encType="application/json">

                                                                <input type="hidden" name="commentId" data-id={CommentID_forReply} value={CommentID_forReply} />
                                                                <input type="hidden" name="collectionId" value={_collIDParam} />
                                                                <input type="hidden" name="collectionName" value={_collectionName} />
                                                                <input type="hidden" name="recordId" value={_recordIDParam} />
                                                                <input type="hidden" name="replyId" value={value.replyId} />
                                                                <input type="hidden" name="babyName" value={_favbabyname} />
                                                                <input type="hidden" name="postType" value="2" />
                                                                <input type="hidden" name="action_status" value="0" />
                                                                <input type="hidden" name="action_type" value="like" />
                                                                <input type="hidden" name="headerdata" value={'ftk:' + global.ftk + ',,uid:' + global.uID + ',,access-token:' + global.accessToken + ',,user-agent:' + global.userAgent + ',,isdesktop:' + global.isdesktop} />
                                                                <input type="hidden" name="currentUrl" value={global.currentURL} />
                                                                {value.isLiked ?
                                                                    (
                                                                        <label htmlFor="heartClk">
                                                                            <input type="hidden" name="postType" value="2" />
                                                                            <input type="hidden" name="action_status" value="0" />
                                                                            <input type="hidden" name="action_type" value="like" />
                                                                            <input type="submit" role="button" id="heartClk" tabIndex="0" value="" />
                                                                            <span className="icon left like_name isliked" data-icon-font="T" onClick={(e) => this.likeToComment(`${_recordIDParam}`, `${CommentID_forReply}`, `${value.replyId}`, `${_collIDParam}`, `${_collectionName}`, `${_favbabyname}`, value.likeCount, "2", e)}></span>
                                                                        </label>
                                                                    ) :
                                                                    (
                                                                        <label htmlFor="heartClk">
                                                                            <input type="hidden" name="postType" value="2" />
                                                                            <input type="hidden" name="action_status" value="0" />
                                                                            <input type="hidden" name="action_type" value="like" />
                                                                            <input type="submit" role="button" id="heartClk" tabIndex="0" value="" />
                                                                            <span className="icon left like_name isliked" data-icon-font="T" onClick={(e) => this.likeToComment(`${_recordIDParam}`, `${CommentID_forReply}`, `${value.replyId}`, `${_collIDParam}`, `${_collectionName}`, `${_favbabyname}`, value.likeCount, "2", e)}></span>
                                                                        </label>

                                                                    )
                                                                }
                                                            </form>

                                                        }
                                                        {
                                                            (value.likeCount > 1) ?
                                                                (
                                                                    <span className="R13_9e likeCounts" onClick={(e) => actions.showUserLikes(`${_recordIDParam}`, `${_collIDParam}`, `${CommentID_forReply}`, `${value.replyId}`, 2)}>{value.likeCount} Likes</span>
                                                                ) :
                                                                (
                                                                    (value.likeCount == 1) ?
                                                                        (
                                                                            <span className="R13_9e likeCounts" onClick={(e) => actions.showUserLikes(`${_recordIDParam}`, `${_collIDParam}`, `${CommentID_forReply}`, `${value.replyId}`, 2)}>{value.likeCount} Like</span>
                                                                        ) :
                                                                        (
                                                                            <span className="R13_9e likeCounts" onClick={(e) => actions.showUserLikes(`${_recordIDParam}`, `${_collIDParam}`, `${CommentID_forReply}`, `${value.replyId}`, 2)}></span>
                                                                        )
                                                                )
                                                        }

                                                        {
                                                            (global.userAry['mycid'] != value.replyCreatorId && this.state.isCreater) ?
                                                                (
                                                                    (!value.isAbuse) ?
                                                                        (
                                                                            <React.Fragment>
                                                                                <span className="R13_9e icon abuse_icon right" data-icon-font="&#xe002;" onClick={(e) => actions.showTool(e)}></span>
                                                                                <div className="abuse-tooltip R14_9e abused_already" onClick={(e) => actions.reportAbuse(`${_recordIDParam}`, `${_collIDParam}`, `${CommentID_forReply}`, `${value.replyId}`, e, this)}>Report Abuse</div>

                                                                            </React.Fragment>


                                                                        ) :
                                                                        (
                                                                            <React.Fragment>
                                                                                <span className="R13_9e icon abuse_icon right isChecked" data-icon-font="&#xe002;" onClick={(e) => actions.showTool(e)}></span>
                                                                                <div className="abuse-tooltip R14_9e abused_already">Already Reported Abuse</div>

                                                                            </React.Fragment>
                                                                        )
                                                                ) :
                                                                ''
                                                        }
                                                    </div>
                                                </li>
                                            )
                                        }
                                    </ul>
                                </div>
                            </div>
                            {/*  <!--replies list ends-->  */}
                            {/*  <!--abuse overlay-->  */}
                            <div className="abuse-overlay" id="abuse-overlay" hidden>
                                <div className="abuse-popup">
                                    <span className="left"></span>
                                </div>
                            </div>
                            {/*  <!--abuse overlay-->  */}
                            <div className="name-added">
                                <div className="nm-add">
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        )
    }
}

export default SharedCollectionAmp



// WEBPACK FOOTER //
// src/shared/baby-names-amp/SharedCollectionAmp.js